module.exports = __webpack_public_path__ + "img/20190729161706615.bc51e6b8.png";